export const OPEN_USER_MODAL = 'OPEN_USER_MODAL'

export function openUserModal(payload: {
  user?: Record<string, unknown>
  district?: Record<string, unknown>
  school?: Record<string, unknown>
}) {
  return {
    type: OPEN_USER_MODAL,
    payload,
  }
}
